export const DATE_TIME_FORMAT = 'MM/DD/YYYY h:mm a';
export const SHORT_DATE_FORMAT = 'MM/DD/YYYY';
